import React, { Component } from 'react';
import axios from 'axios';
import { MSG_ERR, MSG_OK } from '../App';
import LoadingSpinner from './LoadingSpinner';

const BANK_CHOICES = [
  ['BDV', 'Banco de Venezuela'],
  ['BNS', 'Banesco'],
  ['MER', 'Mercantil'],
  ['PRV', 'BBVA Provincial'],
  ['EXT', 'Banco Exterior'],
  ['BNC', 'BNC'],
  ['BIC', 'Bicentenario'],
  ['ACT', 'Activo Bank'],
  ['FC',  'Fondo Común'],
  ['BT',  'Banco del Tesoro'],
];

const EDITABLE_FIELDS = [
  'col_birthdate',
  'col_gender',
  'col_urb',
  'col_muni',
  'col_ciudad',
  'col_estado',
  'col_pais',
  'col_cedula',
  'col_celular',
  'col_banco',
];

class CollaboratorSettings extends Component {
  state = {
    loading: true,
    saving: false,
    first_name: '',
    last_name: '',
    group_names: [],
    col_birthdate: '',
    col_gender: '',
    col_urb: '',
    col_muni: '',
    col_ciudad: '',
    col_estado: '',
    col_pais: '',
    col_cedula: '',
    col_celular: '',
    col_banco: '',
    cedula_prefix: 'V',
    cedula_digits: '',
  };

  getColId = () => localStorage.getItem('colId');

  loadProfile = () => {
    const colId = this.getColId();
    const { displayMsg } = this.props;
    if (!colId) {
      displayMsg('Debe iniciar sesión', MSG_ERR);
      this.setState({ loading: false });
      return;
    }
    this.setState({ loading: true });
    axios
      .get(`/api/collaborator/${colId}/`, {
        headers: { Authorization: `Token ${localStorage.getItem('token')}` },
      })
      .then((res) => {
        const data = res.data || {};
        const cedula = data.col_cedula || '';
        const prefix = cedula.length > 0 ? cedula[0] : 'V';
        const digits = cedula.length > 1 ? cedula.slice(1) : '';
        this.setState({
          loading: false,
          first_name: data.first_name || '',
          last_name: data.last_name || '',
          group_names: data.group_names || [],
          col_birthdate: data.col_birthdate || '',
          col_gender: data.col_gender || '',
          col_urb: data.col_urb || '',
          col_muni: data.col_muni || '',
          col_ciudad: data.col_ciudad || '',
          col_estado: data.col_estado || '',
          col_pais: data.col_pais || '',
          col_cedula: cedula,
          col_celular: data.col_celular || '',
          col_banco: data.col_banco || '',
          cedula_prefix: prefix,
          cedula_digits: digits,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        displayMsg('Error al cargar datos. Intente de nuevo.', MSG_ERR);
      });
  };

  componentDidMount() {
    this.loadProfile();
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleCedulaChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cedula_prefix') {
      const digits = this.state.cedula_digits;
      this.setState({ cedula_prefix: value, col_cedula: value + digits });
    } else {
      const digits = value.replace(/\D/g, '').slice(0, 8);
      this.setState({ cedula_digits: digits, col_cedula: this.state.cedula_prefix + digits });
    }
  };

  handleCelularChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 11);
    let formatted = raw;
    if (raw.length > 4) formatted = raw.slice(0, 4) + '-' + raw.slice(4);
    this.setState({ col_celular: formatted });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const colId = this.getColId();
    const { displayMsg, onCancel } = this.props;
    if (!colId) {
      displayMsg('Debe iniciar sesión', MSG_ERR);
      return;
    }
    this.setState({ saving: true });
    const payload = {};
    EDITABLE_FIELDS.forEach((f) => {
      const v = this.state[f];
      payload[f] = v === '' ? null : v;
    });
    axios
      .patch(`/api/collaborator/${colId}/`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': localStorage.getItem('csrftoken'),
          Authorization: `Token ${localStorage.getItem('token')}`,
        },
      })
      .then(() => {
        this.setState({ saving: false });
        displayMsg('Datos guardados correctamente', MSG_OK);
        if (onCancel) onCancel();
      })
      .catch(() => {
        this.setState({ saving: false });
        displayMsg('Error al guardar. Intente de nuevo.', MSG_ERR);
      });
  };

  render() {
    const { onCancel } = this.props;
    const { loading, saving, first_name, last_name, group_names } = this.state;

    if (loading) {
      return (
        <div className="container py-3">
          <LoadingSpinner message="Cargando datos…" />
        </div>
      );
    }

    return (
      <div className="container py-3">
        <div className="mb-3">
          <h5 className="mb-1">Datos Personales</h5>
          <p className="mb-0 small text-secondary">
            <span className="me-3">
              <span className="text-muted">Logged in as:</span>{' '}
              <strong>{first_name} {last_name}</strong>
            </span>
          </p>
          <p className="mb-0 small text-secondary">
            <span className="text-muted">Status:</span>{' '}
            <strong>{group_names.length > 0 ? group_names.join(', ') : '—'}</strong>
          </p>
        </div>
        <div className="card shadow-sm">
          <div className="card-body">
            <form onSubmit={this.handleSubmit}>
              <div className="row g-2">
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Fecha de nacimiento</label>
                  <input
                    type="date"
                    name="col_birthdate"
                    className="form-control form-control-sm"
                    value={this.state.col_birthdate}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Género</label>
                  <select
                    name="col_gender"
                    className="form-select form-select-sm"
                    value={this.state.col_gender}
                    onChange={this.handleChange}
                  >
                    <option value="">—</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                    <option value="O">Otro</option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label small text-muted">Barrio / Urbanización</label>
                  <input
                    type="text"
                    name="col_urb"
                    className="form-control form-control-sm"
                    placeholder="Ej. Centro"
                    value={this.state.col_urb}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Municipio</label>
                  <input
                    type="text"
                    name="col_muni"
                    className="form-control form-control-sm"
                    value={this.state.col_muni}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Ciudad</label>
                  <input
                    type="text"
                    name="col_ciudad"
                    className="form-control form-control-sm"
                    value={this.state.col_ciudad}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Estado / Departamento</label>
                  <input
                    type="text"
                    name="col_estado"
                    className="form-control form-control-sm"
                    value={this.state.col_estado}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">País</label>
                  <input
                    type="text"
                    name="col_pais"
                    className="form-control form-control-sm"
                    value={this.state.col_pais}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <hr className="my-3" />
              <h6 className="text-muted mb-2">Datos Pago Móvil</h6>
              <div className="row g-2">
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Cédula</label>
                  <div className="d-flex gap-1">
                    <select
                      name="cedula_prefix"
                      className="form-select form-select-sm"
                      style={{ width: '70px', flexShrink: 0 }}
                      value={this.state.cedula_prefix}
                      onChange={this.handleCedulaChange}
                    >
                      <option value="V">V</option>
                      <option value="E">E</option>
                    </select>
                    <input
                      type="text"
                      name="cedula_digits"
                      className="form-control form-control-sm"
                      placeholder="12345678"
                      inputMode="numeric"
                      value={this.state.cedula_digits}
                      onChange={this.handleCedulaChange}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Celular</label>
                  <input
                    type="text"
                    name="col_celular"
                    className="form-control form-control-sm"
                    placeholder="0414-1234567"
                    inputMode="numeric"
                    value={this.state.col_celular}
                    onChange={this.handleCelularChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label small text-muted">Banco</label>
                  <select
                    name="col_banco"
                    className="form-select form-select-sm"
                    value={this.state.col_banco}
                    onChange={this.handleChange}
                  >
                    <option value="">— Seleccionar —</option>
                    {BANK_CHOICES.map(([code, label]) => (
                      <option key={code} value={code}>{label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-3 d-flex gap-2">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm"
                  disabled={saving}
                >
                  {saving ? 'Guardando…' : 'Guardar'}
                </button>
                {onCancel && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => onCancel()}
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CollaboratorSettings;
